export const buildingInclude = 'clients,buildingProductStates.product';

export const buildingSearchQueryBase = {
	_d2dState: true,
	types: 'detached,semidetached,otherdetached,unknown,vacationhome',
	_limit: 25,
	_sort: 'address',
};
